import { useTranslations } from 'use-intl';
import { useFormatters } from '@financialharmony/ui';

/**
 * A date for display in the language the app shows, or `placeholder` (default: "No due date") when
 * there is none or it does not parse. A draft has no due date until a person enters one (FIN-1100),
 * and `new Date("")` would render "Invalid Date".
 */
export function useFormatOptionalDate() {
  const t = useTranslations('consultantShell.dates');
  const { formatDate } = useFormatters();
  return (date: string | null | undefined, placeholder: string = t('noDueDate')): string => {
    if (!date || Number.isNaN(new Date(date).getTime())) return placeholder;
    return formatDate(date, 'numeric');
  };
}
